import React, {useContext, useEffect, useState, Fragment} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import {BaseUrl} from "../../../../../contexts/baseUrl/baseUrl";
import Layout from "../../../../../components/sales/layout/layout";

const B2CLeadList = ({
                        match,
                        b2cLeadListRequest,
                         b2cLeadListResponse = []
                    }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [id, setId] = useState('');
    const  [roleId, setRoleId] = useState();
    const [userId, setUserId] = useState()

    useEffect(() => {
        (async () => {
            setRoleId(window.localStorage.getItem('fusion-role'));
            setUserId(JSON.parse(window.localStorage.loginDetails)?.id)
            setIsLoading(true)
            await b2cLeadListRequest('GET_LEADS_FOR_LOGGED_IN_REQUESTS')
            setIsLoading(false)
        })()
    }, [])

    const headers = [
        'Loan Id',
        'Name',
        'Vehicle Type',
        'Mobile No',
        'Aadhar No',
        'Created At',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await b2cLeadListRequest('GET_LEADS_FOR_LOGGED_IN_REQUESTS', val.selected + 1);
        setIsLoading(false);
    };

    useEffect(() => {

        if (b2cLeadListResponse && b2cLeadListResponse?.data  &&
            b2cLeadListResponse?.data?.resultSets && b2cLeadListResponse?.data?.resultSets.length > 0) {
            // const tableData = ['loan_application_id', 'name', 'vehicle_type', 'mobile_number', 'aadhar_number','created_at'];
            const tableData = ['loan_lead_id', 'name', 'vehicle_type', 'mobile_number', 'aadhar_number','created_at'];
            const data = b2cLeadListResponse?.data?.resultSets.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        {[key]: element[key]}
                    )),
                    {Action: [
                            // { name: 'View Details', link: `${baseUrl}/ucd/view` },
                            // { name: 'Add New Case', link: `${baseUrl}/ucd/b2c-edit/${element['loan_application_id']}` },
                            { name: 'Add New Case', link: `${baseUrl}/ucd/b2c-edit/${element['loan_lead_id']}` },
                            // { name: 'View', link: `${baseUrl}/ucd/case-view/${element['loan_application_id']}` },
                            // ((parseInt(roleId) === 54 || parseInt(roleId) === 55)) ? {name: 'PennyDrop', link: `${baseUrl}/ucd/case/account-penny-drop/${element['loan_application_id']}`} : "",
                            // ((parseInt(roleId) === 13)) ? { name: 'Payment Release Request', link: `${baseUrl}/ucd/case/payment-raise-view/${element['loan_application_id']}`} : "",
                        ]},
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(b2cLeadListResponse?.data?.total / b2cLeadListResponse?.data?.per_page));
        }
    }, [b2cLeadListResponse])


    return (
        <>
            <Layout
                title={"Case Listing"}
                isLoading={isLoading}
                isGoback={true}
                // Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={b2cLeadListResponse?.data?.resultSets}
                    srNo={b2cLeadListResponse?.data?.from}
                    carLoanId={setId}
                />
            </Layout>
        </>
    )
}

export default B2CLeadList

